import { Row } from 'components/Blocks';
import { getFirstAndLastName, getFirstWord } from 'utils/text';

import { TaskWithSub } from 'entities';
import { UserAvatarGroup } from 'components/UserAvatar';

interface TaskUsersProps {
  children?: never;
  task: TaskWithSub;
}

function TaskUsers({ task: { owner, subOwner } }: TaskUsersProps): JSX.Element {
  return (
    <Row gap="2" className="ml-1.5">
      <UserAvatarGroup
        users={[owner, subOwner]}
        size={32}
        className="justify-center"
        avatarClassName="text-sm"
      />

      <p className="text-start">
        {subOwner
          ? `${getFirstWord(owner.name)} & ${getFirstWord(subOwner.name)}`
          : getFirstAndLastName(owner.name)}
      </p>
    </Row>
  );
}

export default TaskUsers;
